export default __webpack_public_path__ + "static/media/Criminalising Ecocide Peacetime Ecocide - Garv Sharma.247e75a7.pdf";